
import XHeader from './XHeader/index'
import XBody from './XBody'
import XFooter from './XFooter'
import Sidebar from './Sidebar/index'
import Wrapper from './Wrapper'
import Layout from './Layout'
import Pagination from './Pagination'
import Placeholder from './Placeholder/index'
import ContentBox from './ContentBox'
import {Cellbox, CellItem} from './Cellbox/index'


const components = {
  XHeader,
  XBody,
  XFooter,
  Sidebar,
  Wrapper,
  Layout,
  Pagination,
  Placeholder,
  Cellbox,
  CellItem,
  ContentBox
}

const install = function (Vue) {
  for (let name in components) {
    Vue.component(name, components[name])
  }
}

export {
  install,
  XHeader,
  XBody,
  XFooter,
  Sidebar,
  Wrapper,
  Layout,
  Pagination,
  Placeholder,
  Cellbox,
  CellItem,
  ContentBox
}
